<template>
  <div>
    <div class="h-topo_pw" v-show="see">
      <!-- <div class="h-topo_pw"> -->

      <div class="h-topo_pw_top">
        <div class="h-topo_wytb1">
          <span :class="['icon hero-icon '+icon+ ' '+online]"></span>
        </div>
        <div class="h-topo_wytb_topwz" :title='devInfo.name'>{{$t('Topo.trunkName')}}：{{devInfo.name}}</div>
        <div class="h-topo_wytb2">
          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-Expand"></span>
        </div>
      </div>
      <div class="h-topo_pw_bottom" v-if="seeBottom">
        <div class="h-topo_wybox">
          <div class="h-topo_wytb3"></div>
          <div class="h-topo_wytb3">
            <span class="e-btn-icon icon hero-icon hero-icon-detailed"></span>
          </div>
          <div class="h-topo_xq">{{$t('Topo.serveDetail')}}</div>
          <div class="h-topo_wytb_wz">
            <table class="h-topo_tableheight">
              <tr>
                <td>{{$t('Topo.trunkCode')}}: {{typeCode}}</td>
              </tr>
    
              <tr>
                <td>{{$t('Topo.physicalIP')}}: {{devInfo.ip}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.physicalPort')}}:{{devInfo.port}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.devSoftVersion')}}:{{devInfo.displaySoftwareVersion}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

import { EventBus } from '../../plugins/eventBus';

  export default {
  name: "TrunkPanelBoardShow",
  components: {
    
  },
  data() {
    return {
      typeCode: "",
      devInfo: {},
      see: false,
      seeBottom: false,
      id: "",
      type: "",
      icon: "",
      online: "",
    };
  },
  props: ["trunkShowObj"],
  methods: {
    panelBoardGetData() {
      this.axios
        .get(`/lte/ems/topo/trunk/findTrunk/${this.id}`)
        .then(response => {
          if (response.data.errorCode === 'SUCCESS') {
            this.devInfo = response.data.resultVal;
          }
        });
    },

    // 去后台查集群类型
        queryTrunkType() {
      const This = this;
      This.$axios.get('/lte/ems/topo/trunk/findTrunkType').then(response => {
          if(response.data === undefined){
            return;
          }
          if (response.data.errorCode === 'SUCCESS') {
            This.typeCode = response.data.resultVal[0].nameKey;   
            this.icon = This.typeData[index].icon;


          } else if(response.status === 401) {
            EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
      });
    },
    click() {
      this.seeBottom = !this.seeBottom;
    },

  },

  mounted() {},
  watch: {
    //父子动态传值
    trunkShowObj: {
      handler: function(newVal, oldVal) {
        this.see = newVal.seeObj;
        this.seeBottom = newVal.seeBottomObj;
        this.id = newVal.idObj;
        this.type = newVal.typeObj;
                if(newVal.onlineObj===1){
         this.online='h-pm-iconOnline';
        }       else if(newVal.onlineObj===0){
         this.online='h-pm-iconOffline';
        }
        this.panelBoardGetData();
        this.queryTrunkType();
      },
      deep: true
    }
  }
};
</script>
<style>
</style>
